module.exports = __webpack_public_path__ + "static/media/BDD_SetUpScreens_Food.72157118.png";